import React, { useState } from 'react';
import { CircularProgress } from '@mui/material';
import Input from '../../../../../../components/Input';
import Button from '../../../../../../components/Button';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/redux';
import { EChangeCutOffTime } from '../../types';
import { cutOffTimeSlice, addCutOffTime, editCutOffTime } from '../../../../../../store/reducers/cutOffTimeSlice';
import css from './AddEditCutOffTime.module.scss';

type TAddEditCutOffTime = {
  setChangeState: React.Dispatch<React.SetStateAction<EChangeCutOffTime>>;
};

export const AddEditCutOffTime = ({ setChangeState }: TAddEditCutOffTime) => {
  const dispatch = useAppDispatch();
  const { setEditCcyId } = cutOffTimeSlice.actions;
  const { intregrations, paramsId } = useAppSelector((state) => state.integrationReducer);
  const { cutOffTime, ccyId, loading } = useAppSelector((state) => state.cutOffTimeReducer);
  const cutOffTimeItem = cutOffTime?.find(item => item.ccyId === ccyId);
  const emptyState = {
    paramsId: paramsId || '',
    currency: ccyId ? cutOffTimeItem?.currency || '' : '',
    time: '',
  };
  const [fields, setFields] = useState<{
    paramsId: string;
    currency: string;
    time: string;
  }>(emptyState);
  const intregration = intregrations?.find((item) => item.paramsId === paramsId);
  const addCutOffTimeHandler = () => {
    dispatch(addCutOffTime(fields)).then((response) => {
      // @ts-ignore
      if (response?.payload?.ccyId) {
        dispatch(setEditCcyId(null));
        setChangeState(EChangeCutOffTime.LIST);
      }
    });
  };
  const editCutOffTimeHandler = () => {
    dispatch(editCutOffTime({ ccyId: ccyId || '', time: fields.time })).then((response) => {
      // @ts-ignore
      if (response?.payload?.ccyId) {
        setChangeState(EChangeCutOffTime.LIST);
      }
    });
  };

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <section className={css.root}>
      <div className={css.inputs}>
        <Input
          label="Channel Name"
          placeholder="Select Name"
          value={intregration?.name || ''}
          disabled
          onChange={() => {}}
        />
        <Input
          label="Currency"
          placeholder="Select currency"
          value={fields.currency}
          disabled={!!ccyId}
          onChange={(e) => setFields({ ...fields, currency: e.target.value })}
        />
        <Input
          label="Time"
          placeholder="Select time"
          value={fields.time}
          onChange={(e) => setFields({ ...fields, time: e.target.value })}
        />
      </div>
      <div className={css.buttons}>
        <Button onClick={() => ccyId ? editCutOffTimeHandler() :  addCutOffTimeHandler()}>Save</Button>
        <Button
          color="error"
          onClick={() => {
            setChangeState(EChangeCutOffTime.LIST);
            setFields(emptyState);
          }}
        >
          Cancel
        </Button>
      </div>
    </section>
  );
};
